import(/* webpackMode: "eager" */ "/root/services/fash-creative/src/app/auth/signup/page.tsx")